import { BaseError } from './base.js';
export class InvalidAddressError extends BaseError {
  constructor(_ref) {
    let {
      address
    } = _ref;
    super("Address \"".concat(address, "\" is invalid."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidAddressError'
    });
  }
}
//# sourceMappingURL=address.js.map